import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, CalendarDays, CircleUser, Car, KeyRound } from "lucide-react";
import { useAuth } from "../lib/auth";

/** App-style bottom navigation on phones. Hidden on md+ (desktop uses the top navbar). */
export default function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (pathname.startsWith("/login") || pathname.startsWith("/register") || pathname.startsWith("/booking/success")) return null;

  const tabs = [
    { to: "/", label: "Home", icon: Home, end: true },
    { to: "/vehicles", label: "Cars", icon: Search },
  ];
  if (user?.role === "owner") tabs.push({ to: "/owner", label: "Hosting", icon: KeyRound });
  else if (user?.role === "driver") tabs.push({ to: "/driver", label: "Trips", icon: Car });
  else tabs.push({ to: user ? "/dashboard" : "/login?next=/dashboard", label: "Trips", icon: CalendarDays });
  tabs.push({ to: user ? "/dashboard/profile" : "/login", label: user ? "Account" : "Log in", icon: CircleUser });

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur border-t border-[#E2E8F0]" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="mobile-tab-bar" aria-label="Primary">
      <ul className="grid grid-cols-4">
        {tabs.map((t) => (
          <li key={t.label}>
            <NavLink
              to={t.to}
              end={t.end}
              className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] font-semibold transition-colors ${isActive ? "text-[#1d7ffd]" : "text-[#64748B]"}`}
              data-testid={`tab-${t.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {({ isActive }) => (
                <>
                  <t.icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
                  {t.label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
